import React, { Component } from 'react';
import authAxios from "../../services/Token";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFilePdf, faSearch, faUndo } from "@fortawesome/free-solid-svg-icons";
import Swal from 'sweetalert2';
import Url from "../../services/Api";

export default class LiquidacionesConductor extends Component {
    constructor(props) {
        super(props);
        this.state = {
            liquidaciones: [],
            liquidacionesFiltradas: [],
            cargando: false,
            filtroNombre: ''
        };
    }

    componentDidMount() {
        this.cargarLiquidaciones();
    }

    cargarLiquidaciones = async () => {
        this.setState({ cargando: true });
        try {
            const response = await authAxios.get("liquidaciones/lista");
            if (response.data.Status || response.data.status) {
                this.setState({ liquidaciones: response.data.dato, liquidacionesFiltradas: response.data.dato });
            }
        } catch (error) {
            console.error("Error cargando liquidaciones", error);
            Swal.fire("Error", "No se pudieron cargar las liquidaciones.", "error");
        } finally {
            this.setState({ cargando: false });
        }
    };

    handleInputChange = (e) => {
        const { value } = e.target;
        this.setState({ filtroNombre: value }, this.filtrar);
    };

    filtrar = () => {
        const { liquidaciones, filtroNombre } = this.state;
        const lowerFiltro = filtroNombre.toLowerCase();
        const filtradas = liquidaciones.filter(l => 
            (l.nombre_mostrar || '').toLowerCase().includes(lowerFiltro) || 
            (l.conductor_identificacion || '').toLowerCase().includes(lowerFiltro) ||
            String(l.id).includes(lowerFiltro)
        );
        this.setState({ liquidacionesFiltradas: filtradas });
    };

    limpiar = () => {
        this.setState({ filtroNombre: '', liquidacionesFiltradas: this.state.liquidaciones });
    };

    descargarPdf = (id) => {
        window.open(`${Url}liquidaciones/pdf/${id}`, '_blank');
    };

    render() {
        const { liquidacionesFiltradas, cargando, filtroNombre } = this.state;

        return (
            <div className="container-fluid mt-3">
                <div className="card shadow-sm">
                    <div className="card-header bg-primary text-white">
                        <h5 className="mb-0">Historial de Liquidaciones de Servicio</h5>
                    </div>
                    <div className="card-body bg-light">
                        <div className="row g-2 align-items-end mb-3">
                            <div className="col-md-4">
                                <label className="form-label fw-bold">Buscar por Nombre, Cédula o ID</label>
                                <input 
                                    type="text" 
                                    className="form-control form-control-sm"
                                    value={filtroNombre}
                                    onChange={this.handleInputChange}
                                    placeholder="Ingrese término de búsqueda..."
                                />
                            </div>
                            <div className="col-md-4">
                                <button onClick={this.filtrar} disabled={cargando} className="btn btn-primary btn-sm px-3 shadow-sm me-2">
                                    <FontAwesomeIcon icon={faSearch} className="me-2" /> Buscar
                                </button>
                                <button onClick={this.limpiar} disabled={cargando} className="btn btn-secondary btn-sm px-3 shadow-sm">
                                    <FontAwesomeIcon icon={faUndo} className="me-2" /> Limpiar
                                </button>
                            </div>
                        </div>

                        <div className="table-responsive">
                            <table className="table table-bordered table-hover text-center align-middle" style={{ fontSize: '13px' }}>
                                <thead className="table-light">
                                    <tr>
                                        <th>ID Liquidación</th>
                                        <th>Fecha</th>
                                        <th>Cédula Conductor</th>
                                        <th>Nombre</th>
                                        <th>Cant. Servicios</th>
                                        <th>Valor Total</th>
                                        <th>Acciones</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {cargando ? (
                                        <tr><td colSpan="7" className="py-4">Cargando...</td></tr>
                                    ) : liquidacionesFiltradas.length > 0 ? (
                                        liquidacionesFiltradas.map((item, i) => (
                                            <tr key={i}>
                                                <td><strong>#{item.id.toString().padStart(3, '0')}</strong></td>
                                                <td>{item.fecha}</td>
                                                <td>{item.conductor_identificacion}</td>
                                                <td>{item.nombre_mostrar}</td>
                                                <td><span className="badge bg-primary fs-6">{item.cantidad_servicios || 0}</span></td>
                                                <td>$ {Number(item.valor_total).toLocaleString()}</td>
                                                <td>
                                                    <button 
                                                        className="btn btn-danger btn-sm"
                                                        onClick={() => this.descargarPdf(item.id)}
                                                        title="Descargar PDF"
                                                    >
                                                        <FontAwesomeIcon icon={faFilePdf} /> PDF
                                                    </button>
                                                </td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan="7" className="py-4 text-muted">No se encontraron liquidaciones.</td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
